<template>
  <div class="page">
    <el-container>
      <el-main class="table-wrap">
        <div style="margin-bottom: 10px">
          <el-button
            type="primary"
            size="mini"
            class="green-btn"
            @click="exportExcel"
            >导出
          </el-button>
          <el-button size="mini" class="orange-btn" type="warning" @click="importExcel" :disabled="!releaseType"
            >导入
          </el-button>
          <el-button size="mini" class="orange-btn" type="warning" @click="release" :disabled="!releaseType"
            >发布
          </el-button>
        </div>
        <el-table
          ref="table"
          :height="tableHeight"
          border
          :data="tableData.records"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          style="width: 100%"
          v-loading="loading"
          element-loading-text="数据加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column
            show-overflow-tooltip
            :label="item.displayName"
            :fixed="item.freezeType"
            :prop="item.columnName"
            v-for="(item, index) in columnData"
            :key="item.columnName + index"
            :align="`${item.fieldType == 'string'? 'left' : 'right' }`"
          >
            <template
              #header
              v-if="item.fieldType == 'string' && item.displayName != '图片'"
            >
              <q-table-header-filter
                :prop="item.columnName"
                :label="item.displayName"
                :useSort="true"
                :filterType="item.fieldType"
                :table="reportName"
                :filterOptions="headerFilterOptions[item.columnName]"
                :getFilterOptions="cheoxList"
                :searchReset="searchReset"
                @confirmFilter="confirmFilter"
                @cheoxList="cheoxList"
              />
            </template>
            <template
              #header
              v-else-if="
                item.fieldType == 'numerical' && item.displayName != '图片'
              "
            >
              <q-table-header-filter
                :prop="item.columnName"
                :label="item.displayName"
                :useSort="true"
                filterType="int"
                :table="reportName"
                :filterOptions="headerFilterOptions[item.columnName]"
                :getFilterOptions="cheoxList"
                :width="item.displayWidth"
                :searchReset="searchReset"
                @confirmFilter="confirmFilter"
                @cheoxList="cheoxList"
              />
            </template>
            <template slot-scope="scope">
              <template v-if="item.displayName === '关联产品数'">
                <el-link
                  :underline="false"
                  type="primary"
                  @click="suitProductList(scope.row.suitCode)"
                  >{{scope.row[item.columnName]}}</el-link
                >
              </template>
              <span v-else>{{
                scope.row[item.columnName] | cellValFormat
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            prop="del"
          >
            <template slot-scope="scoped">
              <el-link
                type="primary"
                :underline="false"
                :disabled="!releaseType"
                @click="delRow(scoped.row.suitCode)"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="auto" style="text-align: right; padding: 15px 0 10px 16px">
        <div style="overflow: hidden;">
        <div style="float: left; line-height: 32px; color: #555;">
            <span>{{ updateData.updateContent }}</span>
            <span>{{ updateData.latestUpdateTime }}</span>
          </div>
          <el-pagination
            style="float: right;"
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </el-footer>
    </el-container>

    <!--新增/编辑弹框-->
    <el-dialog :visible.sync="addDialogVisible" title="关联产品" width="800px">
      <el-table
        ref="table"
        max-height="400"
        border
        :data="dialogTableData.dynamicData ? dialogTableData.dynamicData.records : []"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        style="width: 100%"
        v-loading="loading2"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
            show-overflow-tooltip
            :label="item.titleName"
            :fixed="item.fixed"
            :prop="item.propertyName"
            v-for="(item, index) in dialogTableData.titleList"
            :key="item.titleName + index"
            align="center"
          >
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [pagePathMixin],
  props: ["tableHeight",'queryCriteria','currentProcessCode','batchName','updateData'],
  name: "",
  components: {},
  computed: {
  },
  data() {
    return {
      loading: false,
      loading2: false,
      exportData: {},
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      dialogTableData: [],
      searchFormData: [],
      columnData: [],
      nodeIndex: 6,
      reportName: 'PreDelistAttacheSuitReport',
      exportReportName: 'PreDelistAttacheSuitExport',
      searchReset: false,
      pageTure: false,
      onQueryCriteria: [],
      addDialogVisible: false,
      headerFilterOptions: {},
      columnList: [],
      titleList: [],
      releaseType: true
    };
  },
  mounted() {
    if(this.currentProcessCode) {
      this.init()
      this.columns()
      this.publishStatus()
    }
  },
  methods: {
    columns() {
      let data = [
        {
          paramName: "reportName",
          paramValue: this.reportName,
        },
        {
          paramName: "batchId",
          paramValue: this.searchFormData.filterData.queryCriteria[0].paramValue,
        },
      ];
      this.$q.productLifeCycle.columnsv3({data:data}).then((res) => {
        this.columnData = res.data.sysColumns;
      });
    },
    cheoxList(name, type) {
      this.columnList = [];
      this.columnList = JSON.parse(
        JSON.stringify(this.searchFormData.filterData.queryCriteria)
      );
      let obj = {
        type: "",
        paramValue: "",
        orderBy: "",
        paramName: name,
      };
      this.columnList.forEach((v, index) => {
        if (v && v.paramName == name) {
          delete this.columnList[index];
        }
      });
      this.columnList.push(obj);
      let data = {
        colParam: this.columnList,
        reportName: this.reportName,
      };
      data.colParam = this.columnList.filter((n) => n);
      return this.$q.common.reportGetIndexInfo({ data: data }).then((res) => {
        if (type == "string") {
          this.$set(this.headerFilterOptions, name, res.data.string);
        } else {
          this.$set(this.headerFilterOptions, name, res.data.numerical);
        }
      });
    },
    confirmFilter(filterParam) {
      let that = this;
      let tableName = this.reportName;
      this.common.confirmFilter(that, filterParam, tableName);
    },
    onReset(data) {
      this.$store.commit("headerFilters/delHeaderFilter", this.reportName);
      this.searchReset = true;
      this.tableData.pageNum = 1
      this.onQueryCriteria = data
      this.init();
    },
    onSearch(data) {
      this.$store.commit("headerFilters/delHeaderFilter", this.reportName);
      this.tableData.pageNum = 1;
      this.searchReset = true;
      this.onQueryCriteria = data
      this.init();
    },
    init(item) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.paramValue);
      this.onQueryCriteria = this.onQueryCriteria ? this.onQueryCriteria.filter((item) => item.paramValue) : [];
      let param = {
        filterData: {
          queryCriteria: this.onQueryCriteria.length ? this.onQueryCriteria :  filter,
          reportName: this.reportName,
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      if (this.pageTure && item) {
        param.filterData = item.filterData;
      }
      this.searchFormData = param;
      this.$q.common
        .reportSearch({ data: JSON.stringify(param) })
        .then((res) => {
           if (res.code == 200) {
            this.tableData = res.data;
            this.loading = false;
            this.pageTure = false;
            this.searchReset = false;
          }
          if (null != this.tableData.records) {
            this.loading = false;
          }
         
        });
    },
    async delRow(suitCode) {
      let data = {
        suitCode,
        batchId: this.searchFormData.filterData.queryCriteria[0].paramValue
      }
      let status = await this.$confirm("是否确认删除该条数据？");
      if (status !== "confirm") return;
      let res = await this.$q.productLifeCycle.suitDel({
        data: data
      });
      if (res.success) {
        this.$message.success("删除成功");
        this.onSearch();
      } else {
        this.$message.fail("删除失败");
      }
      
    },
    release() {
      let data = {
        batchId: this.searchFormData.filterData.queryCriteria[0].paramValue,
        processCode: this.nodeIndex,
      };
      this.$q.productLifeCycle.delistPublish({ data: data }).then((res) => {
        if (res.code == 200) {
          this.$message.success("发布成功");
          this.publishStatus();
          this.onSearch();
        }
      });
    },
    publishStatus() {
      let data = {
        batchId: this.searchFormData.filterData.queryCriteria[0].paramValue,
        processCode: this.nodeIndex,
      };
      this.$q.productLifeCycle.publishStatus({ data: data }).then((res) => {
        this.releaseType = res.data;
      });
    },
    suitProductList(suitCode) {
      let data = {
        batchId: this.searchFormData.filterData.queryCriteria[0].paramValue,
        suitCode: suitCode,
      };
      this.$q.productLifeCycle.suitProductList({ data: data }).then((res) => {
        this.dialogTableData = res.data;
        this.addDialogVisible = true
      });
    },
    exportExcel() {
      let params = {
        taskDTO: {
          appCode: "ec-pc-new",
          paramMap: this.searchFormData.filterData,
          reportName: this.exportReportName,
        },
        columnDTOs: null,
      };
      let tmp = JSON.parse(JSON.stringify(this.columnData));

      params.columnDTOs = tmp.map((item) => {
         return {
          columnName: item.displayName,
          fieldName: item.columnName,
          fieldType: item.fieldType,
          columnFormat: item.columnFormat,
          };
      }).filter(v=>v.columnName != '图片');
      this.$q.common
        .customExportExcel({ data: params })
        .then((res) => {
          this.$message({
            type: "success",
            message: "提交下载任务成功，请稍后到导出列表查阅！",
          });
        })
        .catch((err) => {});
    },
    onSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      this.pageTure = true;
      this.init(this.searchFormData);
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.pageTure = true;
      this.init(this.searchFormData);
    },
    importExcel() {
      this.openSubPage({
        path: "/preReturnedProductsImport",
        query: {
          reportName: 'PreDeListSuitImport',
          title: '电商预退套件清单导入',
          batchNo: this.searchFormData.filterData.queryCriteria[0].paramValue,
          batchName: this.batchName
        },
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  beforeDestroy() {
    this.$store.commit("headerFilters/delHeaderFilter", this.reportName);
  },

};
</script>

<style scoped lang="stylus">
.container {
  margin: 5px;
  width: auto;
  height: calc(100% - 20px);
  box-sizing: border-box;
  border-radius: 5px;
}

.header-redio {
  height: 30px;
  line-height: 30px;
  background: #ffffff;
  padding: 0 8px 0 15px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
}

>>> .el-header {
  background: #ffffff;
  padding: 0 8px 0 15px;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
}

>>> .el-main {
  padding: 5px 8px 0px 16px;
  background: #ffffff;
  border-radius: 5px;
}

.header-text {
  color: #606266;
  padding: 10px 0px 0 0;
}

>>> ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

>>> .el-table__body-wrapper {
  z-index: 3 !important;
  position: relative !important;
}

>>> .el-form-item {
  margin-bottom: 0;
}

>>> .yearSelect .el-input {
  width: 100px !important;
}

>>> .yearSelect {
  width: 100px !important;
}

>>> .el-tabs--border-card>.el-tabs__header {
  border-radius: 8px;
}

>>> .el-tabs__nav-wrap {
  border-radius: 8px;
}

>>> .category .el-form-item__label {
  width: 45px !important;
}

.bg-dc-btn {
  background: #FF8900;
  border: none;
  float: right !important;
  margin-right: 4px !important;
}

.bg-dc-btn:hover {
  background-color: rgba(255, 137, 0, 0.8) !important;
}

.search-btn {
  float: left;
  height: 26px;
  line-height: 26px;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  padding: 0 10px;
  margin-right: 10px;
  position: relative;
  top: 8px;
  border-radius: 4px;
}

.search-btn:hover {
  background: rgba(11, 183, 142, 0.8);
}

>>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 0;
}

.categoryCilck {
  color: #0BB78E;
  cursor: pointer;
}

.categoryRed {
  color: #FF3300;
  cursor: pointer;
}
</style>

<style lang="css">
  .el-tooltip__popper {
    max-width: 40%;
  }
</style>
